import { render } from "./LoaderGrid.vue?vue&type=template&id=20030ca4&scoped=true"
import script from "./LoaderGrid.vue?vue&type=script&lang=js"
export * from "./LoaderGrid.vue?vue&type=script&lang=js"

import "./LoaderGrid.vue?vue&type=style&index=0&id=20030ca4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20030ca4"

export default script